<template>
	<div class="float-msg">
		<Robot />
		<Share class="fl-bottom" />
	</div>
</template>
<script>
import Robot from './Robot'
import Share from './Share'
export default {
	components: {
		Robot,
		Share,
	},
}
</script>
<style lang="scss" scoped>
.float-msg {
	position: fixed;
	right: 100px;
	bottom: 100px;
	z-index: 11;
}
.fl-bottom {
	margin-top: 20px;
}
@media (max-width: 768px) {
	.float-msg {
		right: 40px;
		bottom: 40px;
	}
}

@media (max-width: 414px) {
	.float-msg {
		right: 16px;
		bottom: 16px;
	}
}
</style>
